<div class="popup name-browsing searching-result" [ngClass]="show ? 'opened' : ''"
    (click)="handleOnClickPopupContainer($event)">
    <div class="container default-container popup-content">
        <div class="popup-header row">
            <h2 class="col h-medium">{{ 'filter.004' | translate }}</h2>
            <a href="javascript:;" class="col-auto close-popup-btn" (click)="handleOnClickClosePopup();">
                <svg width="22" height="22" viewBox="0 0 22 22">
                    <path d="M1 1L21 21" />
                    <path d="M21 1L1 21" />
                </svg>
            </a>
        </div>
        <div class="popup-body">
            <div class="searching-form">
                <div class="container default-container">
                    <span style="color: red;" [hidden]="isHideLbl">※ 후원인 등록이 가능한 회원만 검색 가능합니다.</span>
                    <div class="row form-row">
                        <!-- Member Name -->
                        <div class="col-sm-5 col-lg-6 info member-name row">
                            <span class="col-auto label">{{ 'filter.005' | translate }} &nbsp; </span>
                            <input class="col" [placeholder]="'placeholder.002' | translate" [(ngModel)]="username"
                                (keydown.enter)="handleOnClickSearch()">
                        </div>
                        <!-- Rank -->
                        <div class="col-7 col-sm col-lg info rank row">
                            <div class="col-auto label"><span>{{ 'filter.003' | translate }} &nbsp; </span></div>
                            <select-dropdown class="dropdown-select col row" [options]="rankOptions"
                                [selected]="rankSelected"
                                (changeSelectedValue)="handleOnChangeRankSelected($event);"></select-dropdown>
                        </div>
                        <!-- Submit Btn -->
                        <div class="col col-sm col-lg w-btn submit-btn" (click)="handleOnClickSearch();">{{ 'common.009'
                            | translate }}</div>
                    </div>
                </div>
            </div>
            
            <div class="container default-container results">
                <div class="table-container">
                    <paging
                    [len]="len"
                    [page]="page"
                    [config]="config"
                    [totalItems]="total"
                    (changePage)="handleOnChangePage($event)"
                    (totalPage)="onTotalPage($event)"
                    (changeLen)="handleOnChangeLenSelected($event)"
                    [turnOnTotalPage]="true"
                    [turnOnPagination]="false"
                    [turnOnTotalItem]="true"
                    [isMobile]="true"
                ></paging>
                    <table class="hr-table">
                        <thead>
                            <tr>
                                <th style="text-align: center;">{{ 'my-office.member.002' | translate }}</th>
                                <th style="text-align: center;">{{ 'my-office.member.003' | translate }}</th>
                                <th style="text-align: center;">{{ 'my-office.member.018' | translate }}</th>
                                <th style="text-align: center;" [hidden]="isHideLbl">{{ 'left' | translate }}</th>
                                <th style="text-align: center;" [hidden]="isHideLbl">{{ 'right' | translate }}</th>
                                <!-- <th style="text-align: center;">{{ 'my-office.member.020' | translate }}</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of items | paginate: config" (click)="handleOnClickRow(item);"
                                [ngClass]="item.status == '0'?'red-line':''">
                                <td style="text-align: center;">{{ item.userid }}</td>
                                <td style="text-align: center;">{{ item.username }}</td>
                                <td style="text-align: center;">{{ item.rankName }}</td>
                                <td style="text-align: center;" [hidden]="isHideLbl">{{ item.lefUser }}</td>
                                <td style="text-align: center;" [hidden]="isHideLbl">{{ item.rightUser }}</td>
                                <!-- <td style="text-align: center;">{{ item.rname }}({{ item.rid }})</td> -->
                            </tr>
                            <ng-container *ngIf="items.length < 5 && items.length > 0">
                                <tr *ngFor="let num of rows">
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td [hidden]="isHideLbl">&nbsp;</td>
                                    <td [hidden]="isHideLbl">&nbsp;</td>
                                </tr>
                            </ng-container>
                        </tbody>
                        <tbody style="position: relative;" *ngIf="items.length === 0">
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td [hidden]="isHideLbl">&nbsp;</td>
                                <td [hidden]="isHideLbl">&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td [hidden]="isHideLbl">&nbsp;</td>
                                <td [hidden]="isHideLbl">&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td><span class='h-small empty-warning'>{{ 'no-data' | translate }}</span></td>
                                <td [hidden]="isHideLbl">&nbsp;</td>
                                <td [hidden]="isHideLbl">&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td [hidden]="isHideLbl">&nbsp;</td>
                                <td [hidden]="isHideLbl">&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td [hidden]="isHideLbl">&nbsp;</td>
                                <td [hidden]="isHideLbl">&nbsp;</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <paging
                [len]="len"
                [page]="page"
                [config]="config"
                [totalItems]="total"
                (changePage)="handleOnChangePage($event)"
                (totalPage)="onTotalPage($event)"
                (changeLen)="handleOnChangeLenSelected($event)"
                [turnOnTotalPage]="true"
                [turnOnPagination]="true"
                [turnOnTotalItem]="true"
                [isMobile]="false"
            ></paging>
            </div>
        </div>
    </div>
</div>